import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAuth } from "../auth/AuthContext";
import cls from "./Layout.module.scss";

const Layout: React.FC = () => {
    const { user } = useAuth();

    return (
        <div className={cls.shell}>
            <Sidebar />
            <main className={cls.main}>
                <div className={cls.card}>
                    <div className={cls.topbar}>
                        <div style={{ fontSize: 18, fontWeight: 700 }}>Панель управления</div>
                        <div style={{ opacity: .8 }}>
                            {user ? <>👤 {user.name || user.email || user.phone} · {user.roles?.join(", ")}</> : "Гость"}
                        </div>
                    </div>
                </div>

                {/* Контент страниц */}
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
